import React from 'react';
import AdminLayout from './AdminLayout';
import VanLayout from './VanLayout';
import WholesaleLayout from './WholesaleLayout';

export default function ConditionalLayout() {
  const auth = JSON.parse(localStorage.getItem('token'));
  const usertype = auth?.usertype;

  if (usertype === 'van') {
    return <VanLayout />;
  }
  else if (usertype === 'wholesaleuser') {
    return <WholesaleLayout />;
  }

  return <AdminLayout />;
}
